/*
 * Broadcast Theme customizations
 */

(function() {
  // Keep the existing sticky add-to-cart scroll behavior.
  window.theme.scrollTo = function(t) {
    const stickyHeader = document.querySelector("[data-header-sticky]");
    const headerHeight = stickyHeader
      ? document.querySelector("[data-header-height]").offsetHeight
      : 0;
    const extraOffset = 16;

    window.scrollTo({
      top: t + window.scrollY - headerHeight - extraOffset,
      left: 0,
      behavior: "smooth"
    });
  };

  // Make the product gallery reliably swipeable on mobile.
  function installProductGallerySwipeFix() {
    if (document.getElementById("vr-product-gallery-swipe-fix")) return;

    const style = document.createElement("style");
    style.id = "vr-product-gallery-swipe-fix";
    style.textContent = `
      @media only screen and (max-width: 749px) {
        product-images.product__images--mobile-slider [data-product-media-list] {
          display: flex !important;
          flex-flow: row nowrap !important;
          justify-content: flex-start !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-x pan-y pinch-zoom !important;
          overscroll-behavior-x: contain !important;
          scroll-snap-type: x mandatory !important;
          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }

        product-images.product__images--mobile-slider [data-product-media-list]::-webkit-scrollbar {
          display: none !important;
        }

        product-images.product__images--mobile-slider [data-product-media-list] > .product__slide {
          flex: 0 0 calc(100% - 50px) !important;
          scroll-snap-align: start !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installProductGallerySwipeFix);
  } else {
    installProductGallerySwipeFix();
  }

  document.addEventListener("shopify:section:load", installProductGallerySwipeFix);

  document.addEventListener("theme:product:add", function () {
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== "drawer") return;

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
    }
  });
})();

